RivalIQ.module('export.enums', function (enums, App, Backbone, Marionette, $, _) {

    'use strict';

    enums.filetypes = {
        IMAGE: 1,
        REPORT: 2,
        RECEIPT: 3,
        PDF: 4,
        CSV: 5
    };
});
